// extracted by mini-css-extract-plugin
module.exports = {"ant-form-item":"addressInformation_ant-form-item_3N1v_"};